import './scripts/global';
import './scripts/animations/animations';
import './scripts/layout/menu';
import './scripts/blocks/block-box-benefits';
import './scripts/blocks/block-media';
import './scripts/blocks/block-table-modal';
import './scripts/blocks/block-hero-holding';
import './scripts/blocks/block-hero-homepage';
import './scripts/blocks/block-hero-secondary';
import './scripts/blocks/block-half-text-media';
import './scripts/blocks/block-half-text-banner';
import './scripts/blocks/block-half-text-portfolio';
import './scripts/blocks/block-half-text-specification';
import './scripts/blocks/block-half-text-location';
import './scripts/blocks/block-half-text-team';
import './scripts/blocks/block-insights';
import './scripts/blocks/block-featured-posts';
import './scripts/blocks/block-latest-posts';
import './scripts/blocks/block-floor-plans';
import './scripts/blocks/block-product-tabs';
import './scripts/components/component-form-modal';
import './scripts/pages/regular-page-energy-beams';
